import axios, { AxiosRequestConfig } from 'axios';

import { API_GATE_WAY } from '@/constant/routes';
import { showToast } from './toast';
const baseURL = API_GATE_WAY;
const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  },
});
type HttpMethod =
  | 'get'
  | 'delete'
  | 'head'
  | 'options'
  | 'post'
  | 'put'
  | 'patch'
  | 'purge'
  | 'link'
  | 'unlink';

type RequestConfig = Exclude<AxiosRequestConfig, 'method' | 'url'>;

export const httpGetRequest = <T>(endpoint: string, config?: RequestConfig) =>
  api<T>({
    method: 'get',
    url: endpoint,
    ...config,
  }).then((res) => res.data);

export const httpPostRequest = <T>(endpoint: string, data: any, config?: RequestConfig) =>
  api<T>({
    method: 'post',
    url: endpoint,
    data,
    ...config,
  });

export const httpPutRequest = <T>(endpoint: string, data: any, config?: RequestConfig) =>
  api<T>({
    method: 'put',
    url: endpoint,
    data,
    ...config,
  });

export const httpPatchRequest = <T>(endpoint: string, data: any, config?: RequestConfig) =>
  api<T>({
    method: 'patch',
    url: endpoint,
    data,
    ...config,
  });

export const httpDeleteRequest = <T>(endpoint: string, config?: RequestConfig) =>
  api<T>({
    method: 'delete',
    url: endpoint,
    ...config,
  });

export const httpCustomRequest = <T>(
  url: string,
  method: HttpMethod,
  data?: any,
  config?: RequestConfig,
) =>
  api<T>({
    method,
    url,
    data,
    ...config,
  });

// INTERCEPTORS
api.interceptors.request.use(async (config) => {
  const accessToken = localStorage.getItem('access_token');
  const tokenType = 'Bearer';
  if (accessToken) {
    config.headers['Authorization'] = `${tokenType} ${accessToken}`;
  }

  return config;
});
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const errCode = error.response.status;

    // if (errCode === 401) {
    //   window.location.href = '/login';
    // } else if (errCode === 404) {
    //   window.location.href = '/not-found';
    // } else if (errCode === 422) {
    //   throw error;
    // } else

    if (errCode >= 400 && errCode <= 499) {
      error.response.data.message && showToast(error.response.data.message);
      // console.log(error);
      throw error;
    }
    if (errCode >= 500 && errCode <= 599) {
      // console.log(error.response);
      throw error;
    }
  },
);
